import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-task-progress',
  templateUrl: './task-progress.component.html',
  styleUrls: [
    './task-progress.component.scss'
  ]
})
export class TaskProgressComponent {
  @Input() stage: number;

  constructor() { }
}
